import { createContext, useState } from "react";



const UserContext = createContext();
export const UserProvider = ({children}) => {
    const [users, setUsers] = useState({
        loginIng: "",
        placeSide: "1",
        id:1,
        usernames: "murat",
        usertype: "",
        firmcode: "",
        subfirmcode: "",
        userDprMain: "",
        userDprSub: "",
        userLang: "",
        dataLang: "",
        accLvl: "",
        
    });

    const values = {users, setUsers};
    return <UserContext.Provider value={values}>{children}</UserContext.Provider>
}


export default UserContext;
